import { lazyWithRetry } from 'components/lazyUtil.js'
const MotorcycleBrands = lazyWithRetry(() => import('../../brands/motorcyclesBrands'))

// IMPORTANT //
// In Future: whenever new route path is added ensure to update "validPaths" in /server/validRoutes.js
const routes = [
  {
    path: '/brand/:brandName',
    component: MotorcycleBrands,
    private: false,
  },
]

export default routes
